<div class="img-widget-width logo-root" [id]="form.displayId()">
    <div class="logo-box" [style.--logo-max-width]="maxWidth()">
        <img class="logo-image" [src]="imgSrc()" [spFallbackImage]="imgFallbackSrc()" alt="placeholder" />
    </div>
</div>
